<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="text-h5 bg-red-lighten-4">
        Cancel Appointment
      </v-card-title>
      <v-card-text class="pt-4">
        <p class="mb-4">Are you sure you want to cancel this appointment?</p>
        <v-textarea
          v-model="cancellationNote"
          label="Cancellation Reason (optional)"
          placeholder="Enter reason for cancellation..."
          variant="outlined"
          rows="3"
          auto-grow
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="text"
          @click="handleCancel"
        >
          No, Keep It
        </v-btn>
        <v-btn
          color="red"
          variant="flat"
          @click="handleConfirm"
        >
          Yes, Cancel Appointment
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel']);

const dialog = ref(props.modelValue);
const cancellationNote = ref('');

watch(() => props.modelValue, (newValue) => {
  dialog.value = newValue;
  if (newValue) {
    // Reset note when dialog opens
    cancellationNote.value = '';
  }
});

watch(dialog, (newValue) => {
  emit('update:modelValue', newValue);
});

function handleConfirm() {
  emit('confirm', cancellationNote.value);
  dialog.value = false;
  cancellationNote.value = '';
}

function handleCancel() {
  emit('cancel');
  dialog.value = false;
  cancellationNote.value = '';
}
</script>
